import React, { useEffect, useState } from 'react';
import { Spin, Modal } from 'antd';
import PropTypes from 'prop-types';

const LoadingComponent = ({ loading, message }) => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    let timer;
    if (loading) {
      setSeconds(0); // 重置計時器
      timer = setInterval(() => {
        setSeconds((prevSeconds) => prevSeconds + 0.1);
      }, 100);
    }
    // 清理計時器
    return () => clearInterval(timer);
  }, [loading]);
  const displaySeconds = seconds.toFixed(1);
  return (
    loading && (
      <Modal
        open={loading}
        footer={null}
        closable={false}
        centered
        maskClosable={false}
        message={message}
        className="loading-component"
      >
        <Spin tip={`Loading... ${displaySeconds} seconds`} size="large">
          <span>
            {message == undefined ? '資料發送讀取中,請稍候！' : message}
          </span>
        </Spin>
      </Modal>
    )
  );
};
LoadingComponent.propTypes = {
  loading: PropTypes.bool.isRequired,
  message: PropTypes.string,
};
export default LoadingComponent;
